import { Document, DocumentType } from '../document';

export type PageType =
  | DocumentType.BRANCH_ACTIVITIES
  | DocumentType.COLD_ARTICLE
  | DocumentType.CONTACT_PAGE
  | DocumentType.FINANCIAL_DEBT
  | DocumentType.FINANCIAL_KEY_FIGURES
  | DocumentType.FINANCIAL_PRESS_RELEASE
  | DocumentType.FINANCIAL_PUBLICATION
  | DocumentType.FINANCIAL_RATING
  | DocumentType.GOUVERNANCE
  | DocumentType.HOME
  | DocumentType.HUB_ACTUS
  | DocumentType.HUB_NEWSROOM
  | DocumentType.HOT_ARTICLE
  | DocumentType.LA_POSTE_EN_4
  | DocumentType.MEDIA_PRESS
  | DocumentType.NEWSROOM
  | DocumentType.POSTMEN
  | DocumentType.PRESS_RELEASE
  | DocumentType.PUBLIC_SERVICE_MISSIONS
  | DocumentType.SEARCH_PAGE;

export type BreadcrumbParent = {
  linkType: string;
  type: string;
  id: string;
  lang: string;
  uid: string;
};

export type Meta = {
  title?: string;
  description?: string;
  image?: string;
  indexed: boolean;
};

export enum FrequenciesEnum {
  WEEKLY = 'weekly',
  ALWAYS = 'always',
  HOURLY = 'hourly',
  DAILY = 'daily',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  NEVER = 'never',
}

export type Page = Document & {
  type: PageType;
  meta: Meta;
  seoText?: string;
  sitemapPriority: number;
  sitemapChangeFrequency: FrequenciesEnum;
  breadcrumbParent?: BreadcrumbParent;
  breadcrumb: string;
  title: string;
  disableRgpbBanner: boolean;
};
